import { useNavigate } from '@tanstack/react-router'
import { Bell } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const AnnouncementButton = () => {
  const navigate = useNavigate()
  const onClick = () => {
    navigate({ to: '/announcement' })
  }
  return (
    <Button variant='ghost' onClick={onClick}>
      <Bell />
    </Button>
  )
}
